export const SchemePaths = {
  Root: '/scheme',
  Overview: '/scheme/overview',
  NoticeBoard: '/scheme/notice-board',
  SchemeCreate: '/scheme/overview/scheme-create',
  SchemeDetails: '/scheme/overview/scheme-details',
} as const;

export const StackingFactorOptions = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
